import React, { Fragment } from "react";
import { Button, Divider, Space } from "antd";
import { useTranslation } from "react-i18next";

interface SelectorFooterProps {
  menu: React.ReactElement;
  selectAll: () => void;
  clearAll: () => void;
  isInputting?: boolean;
}

const SelectorFooter = ({ menu, selectAll, clearAll, isInputting }: SelectorFooterProps) => {
  const { t } = useTranslation();
  return (
    <>
      {menu}
      {!isInputting && (
        <Fragment>
          <Divider style={{ margin: "4px 0" }} />
          <Space>
            <Button
              type="link"
              onClick={selectAll}
              //   onClick={() =>
              //     form.setFieldsValue({
              //       account_parameter: accountOptions.map((o) => o.value),
              //     })
              //   }
            >
              {t("ISMS.SelectAll")}
            </Button>
            <Button
              type="link"
              onClick={clearAll}
              //   onClick={() =>
              //     form.setFieldsValue({
              //       account_parameter: [],
              //     })
              //   }
            >
              {t("ISMS.ClearAll")}
            </Button>
          </Space>
        </Fragment>
      )}
    </>
  );
};

export default SelectorFooter;
